<div class="skv-custom-control skv-custom-control--checkbox" [formGroup]="localGroup">
    <input type="checkbox" class="skv-custom-control__input" [id]="'checkbox' + uniqueId" formControlName="control" />
    <label [for]="'checkbox' + uniqueId" class="skv-custom-control__label">
        <ng-content></ng-content>
    </label>
    <span *ngIf="error" class="text-error text-small">{{error}}</span>
</div>